import {SharedInputEdit} from '../../components/SharedInputEdit';
import {SharedSelect} from "../../components/SharedSelect";

export function OperationsInput(): JSX.Element {

    return (
        <div className="operations --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Nuclear Department</h4>

                    <SharedInputEdit inputName='facility_opening_in_hours'/>
                    <SharedInputEdit inputName='facility_opening_in_days_per_year'/>
                    <SharedInputEdit inputName='percent_of_exams_rescheduled_after_an_event'/>
                    <SharedSelect inputName="product_line"/>
                    <SharedInputEdit inputName='admin_fee_per_rescheduled_patient'/>

                    <SharedSelect inputName='rate_HTM_org_performance'/>
                </div>


            </div>

        </div>

    );
}
